
// import axios from 'axios'
import {instance as axios} from './auth'
import store from '@/store/index'

export function listCategories (lat, lon, locale) {
  let pageSize = 20
  if (store.getters.platform === 'browser') { pageSize = 100 } // no paginamos en web
  let params = {
    'root': true,
    'page_size': pageSize
  }

  if (parseFloat(lat) !== 0 && parseFloat(lon) !== 0) {
    params.latitude = lat
    params.longitude = lon
  }

  if (locale) {
    params.language = locale
  }

  return axios.get('categories/', {params: params})
}

export function getCategory (id, lat, lon) {
  let params = { }
  if (parseFloat(lat) !== 0 && parseFloat(lon) !== 0) {
    params.latitude = lat
    params.longitude = lon
  }

  return axios.get('categories/' + id + '/', {params: params})
}

export function getContent (id, lat, lon) {
  let params = { }
  if (parseFloat(lat) !== 0 && parseFloat(lon) !== 0) {
    params.latitude = lat
    params.longitude = lon
  }

  return axios.get('contents/' + id + '/', {params: params})
}

export function setContentTracking (data) {
  return axios.post('contents/seconds_view/', data)
}

export function searchContent (text, lat, lon, locale) {
  let params = {
    'search2': text,
    'language': locale
  }

  if (parseFloat(lat) !== 0 && parseFloat(lon) !== 0) {
    params.coordinates = `${lat},${lon}`
  } else {
    params.coordinates = `0,0`
  }

  return axios.get('contents/contents/', {params})
}

export function listLiveCategories (lat, lon, locale) {
  let pageSize = 20
  if (store.getters.platform === 'browser') { pageSize = 100 } // no paginamos en web
  let params = {
    'type': 'DIR',
    'page_size': pageSize,
    'language': locale
  }

  if (parseFloat(lat) !== 0 && parseFloat(lon) !== 0) {
    params.latitude = lat
    params.longitude = lon
  }

  return axios.get('categories/', {params: params})
}

export function purchaseSumary (id, type, price) {
  var data = {
    'id': id,
    'type': type.toUpperCase(),
    'price': price
  }
  return axios.post('pay/summary/', data)
}

export function makePurchase (id, inna, device, card, type, total) {
  let data = {
    'id': id,
    'id_inapppurchase': inna,
    'device': device,
    'pay_type': 'STR',
    'card_id': card,
    'type': type.toUpperCase(),
    'total': total
  }
  return axios.post('pay/stripe_purchase/', data)
}

export function getAd (id) {
  return axios.get('ads/ads/get_ads/?content=' + id)
}

export function sendPush (id) {
  return axios.get('interactivities/' + id + '/send_push/')
}

export function sendEmail (id) {
  return axios.get('interactivities/' + id + '/send_email/')
}

export function getPlain (id) {
  return axios.get('plains/' + id + '/')
}

export function getTest (id) {
  return axios.get('tests/' + id + '/')
}

export function setAnswer (test, answer) {
  var data = {
    'test': test,
    'answer': answer
  }
  return axios.post('user_answer/', data)
}

export function paginate (url) {
  return axios.get(url)
}

export function addFavorites (data) {
  return axios.post('contents/favorites/', data)
}

export function deleteFavorites (id) {
  return axios.delete('contents/favorites/' + id + '/')
}

export function lastViewed (data) {
  return axios.post('contents/last_seen/', data)
}

export function getTrailer (data) {
  return axios.post('contents/get_trailer_url/', data)
}



// WEBPACK FOOTER //
// ./src/services/contents.js